import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { clsx } from '../node_modules/clsx/dist/clsx.js';
import { faXmark, faCircleInfo, faCircleCheck, faCircleExclamation, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '../Icon/index.js';
import { Typography } from '../Typography/index.js';
import styles from './styles.module.css.js';

const iconMap = {
    info: faCircleInfo,
    success: faCircleCheck,
    attention: faCircleExclamation,
    error: faCircleXmark,
};
function Alert({ variant, dismissible, children, icon, className, ...props }) {
    const [closed, setClosed] = useState(false);
    return (jsxs("div", { role: "alert", className: clsx(styles.alert, className), "data-variant": variant, "data-state": !closed ? "open" : "closed", ...props, children: [icon && jsx(Icon, { icon: iconMap[variant], className: styles.icon }), jsx(Typography, { variant: "body", size: 2, className: styles.typography, asChild: true, children: jsx("div", { children: children }) }), dismissible && (jsx("div", { className: styles.close, children: jsx("button", { type: "button", className: styles.closeButton, onClick: () => setClosed(true), "aria-label": "Fechar", children: jsx(Icon, { icon: faXmark }) }) }))] }));
}

export { Alert };
//# sourceMappingURL=index.js.map
